import Vue from 'vue'
import Vconsole from 'vconsole'

if (process.env.consoleOff === '1') {
  const vConsole = new Vconsole()
  Vue.use(vConsole)
}



// WEBPACK FOOTER //
// ./src/utils/vconsole.js